interface PostAuthenticationResponse {
	request_id: string;
	status_code: string;
	user_message_title: string;
	user_message_desc: string;
	body_signature: string;
	data: {
		retry: boolean;
	};
}

interface Data {
	retry: boolean;
}

function isPostAuthenticationResponse(obj: any): obj is PostAuthenticationResponse {
	return obj && 
	typeof obj.request_id === 'string' && 
	typeof obj.status_code === 'string' && 
	typeof obj.user_message_title === 'string' && 
	typeof obj.user_message_desc === 'string' && 
	typeof obj.body_signature === 'string' && 
	typeof obj.data === 'object' && 
	typeof obj.data.retry === 'boolean';
}

export class PostAuthenticationDto {
	requestID: string;
	statusCode: string;
	userMessageTitle: string;
	userMessageDesc: string;
	bodySignature: string;
	data: Data;

	constructor(json: PostAuthenticationResponse) {
		if (!isPostAuthenticationResponse(json)) {
			throw new Error('Invalid PostAuthenticationResponse json');
		}
		this.requestID = json.request_id;
		this.statusCode = json.status_code;
		this.userMessageTitle = json.user_message_title;
		this.userMessageDesc = json.user_message_desc;
		this.bodySignature = json.body_signature;
		this.data = {
			retry: json.data.retry
		};
	}
}
